const config = {
    virustotal_configuration: { 0: 'never', 1: 'xx:00', 2: 'xx:00 / xx:30', 3: 'xx:00 / xx:15 / xx:30 / xx:45', 4: 'every 5 mins' }
};

export default config;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerDomains/config/index.js